import { Box, Breadcrumbs, Button, Stack, Tooltip, Typography } from "@mui/material";
import DataModeBadge from "./DataModeBadge";

const PageHeader = ({ title, subtitle, breadcrumbs = [], dataMode, actions, compact = false }) => (
  <Box className="page-heading" sx={{ mb: 2.5 }}>
    <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} gap={2}>
      <Box minWidth={0}>
        {!compact && breadcrumbs.length > 0 && (
          <Breadcrumbs sx={{ mb: 1, color: "text.secondary", fontSize: 12 }}>
            {breadcrumbs.map((item) => (
              <Typography key={item} variant="caption" color="text.secondary">{item}</Typography>
            ))}
          </Breadcrumbs>
        )}
        <Stack direction="row" alignItems="center" gap={1.25} flexWrap="wrap">
          <Tooltip title={compact ? subtitle || "" : ""}><Typography variant="h1" color="text.primary" sx={compact ? { fontSize: 20 } : undefined}>{title}</Typography></Tooltip>
          {dataMode && <DataModeBadge {...dataMode} />}
        </Stack>
        {!compact && subtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 720 }}>{subtitle}</Typography>}
      </Box>
      {actions && <Box>{actions}</Box>}
    </Stack>
  </Box>
);

export const HeaderAction = ({ children, ...props }) => (
  <Button size="small" variant="outlined" {...props}>{children}</Button>
);

export default PageHeader;
